import { queryOptions } from "@tanstack/react-query";
import type { InferResponseType } from "hono/client";
import { api, unwrap } from "@/client/lib/api";

/** Money arrives as decimal strings of minor units; `BigInt` reads them back exactly. */
export type InvoiceListRow = InferResponseType<
  typeof api.invoices.$get,
  200
>["items"][number];

/** The whole set, every page, once: the list filters and sorts it in memory. */
export const invoicesQuery = queryOptions({
  queryKey: ["invoices"],
  queryFn: async (): Promise<InvoiceListRow[]> => {
    const rows: InvoiceListRow[] = [];
    let after: string | undefined;
    do {
      const page = await unwrap(
        api.invoices.$get({ query: after ? { after } : {} }),
      );
      rows.push(...page.items);
      after = page.next ?? undefined;
    } while (after);
    return rows;
  },
});
